// The community gallery's pages by locale (api routes/gallery.py HUB_PATH says the same; a test keeps them equal).
// Its own module: App.tsx routes on it, and the gallery's words stay out of the first bundle.
export const COMMUNITY_PATH = {
  en: '/community', es: '/es/comunidad', pt: '/pt/comunidade', ar: '/ar/community', fr: '/fr/communaute', de: '/de/community',
};
